import * as React from "react"

import { cn } from "@/lib/utils"

interface PrefixedInputProps extends React.ComponentProps<"input"> {
  prefix: string
}

/**
 * Text input with a fixed visual prefix (e.g. "$" or "https://") rendered inside the field.
 *
 * @category Forms
 */
const PrefixedInput = React.forwardRef<HTMLInputElement, PrefixedInputProps>(
  ({ className, prefix, type, ...props }, ref) => {
    return (
      <div
        className={cn(
          "flex h-10 max-lg:h-11 w-full items-stretch overflow-hidden rounded-md border border-input bg-background focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/25 has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-50",
          className
        )}
      >
        <span
          aria-hidden="true"
          className="flex select-none items-center border-r border-input bg-muted px-3 text-sm text-muted-foreground"
        >
          {prefix}
        </span>
        <input
          type={type}
          ref={ref}
          className="min-w-0 flex-1 h-10 max-lg:h-11 bg-transparent px-3 py-2 text-base outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed md:text-sm"
          {...props}
        />
      </div>
    )
  }
)
PrefixedInput.displayName = "PrefixedInput"

export { PrefixedInput }
